import React, { Component } from 'react';
import styled from 'styled-components';
import Swiper from 'swiper';

import MainNav from './components/MainNav';
import MobileNav from './components/MobileNav';

import Home from './components/Home';
import Services from './components/Services';
import Work from './components/Work';
import OurClients from './components/OurClients';
import ForDevelopers from './components/ForDevelopers';
import Contact from './components/Contact';
import WorkWithUs from './components/WorkWithUs';

import Footer from './components/Footer';

import { onSlideAnimations } from './App/helpers';


const AppContainer = styled.div`
  padding: 58px;

  @media (min-width: 992px) {
    height: calc(100vh - 132px);
  }
`;

const MainContent = styled.main`
  padding: 32px 0;
  align-items: center;

  @media (min-width: 992px) {
    height: calc(100% - 64px);
    display: flex;
  }

  @media (max-width: 991px) {
    padding: 61px 0px;
  }
`;

const PagesContainer = styled.div`
  display: flex;
  align-items: center;
`;

const PrivacyContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  display: flex;
  align-items: center;
  height: 100%;
  z-index: 99999;
  opacity: 0;
  -webkit-transition: opacity 0.4s;
  transition: opacity 0.4s;
`;

const PrivacyPage = styled.div`
  background-color: #fff;
  padding: 2vw;
  border: 1px solid;
  margin: 3vw;
  column-count: 2;

  p{
    font-size: 1.2vw;
    line-height: 1.7vw;
  }

  .first-title{
    margin-top: 0;
  }

  @media (max-width: 64em) {
    p{
      font-size: 3.2vw;
      line-height: 4.7vw;
    }
  }
`;

const ClosePrivacyButton = styled.button`
  border: 0;
  margin-top: 1vw;
  background-color: #ffffff;
  padding: 0.5vw 2vw;
  display: inline-block;
  text-align: center;
  font-size: 1.3vw;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  position: relative;
  overflow: hidden;
  -webkit-transition: color 0.4s;
  transition: color 0.4s;
  color: #262636;
  text-decoration: none;
  outline: none;

  &:after{
    background-color: #262636;
    content: '.';
    transform: skewX(15deg);
    position: absolute;
    top: 0;
    left: -10%;
    height: 100%;
    width: 0%;
    color: #262636;
    z-index: 1;
    -webkit-transition: width 0.4s;
    transition: width 0.4s;
  }

  .link-text{
    z-index: 4;
    position: relative;
  }

  &:hover{
    color: #fff;

    &:after{
      width: 120%;
    }
  }

  @media (max-width: 64em) {
    padding: 1.7vw 6vw;
    font-size: 4.3vw;
    margin-top: 5vw;
    margin-bottom: 12vw;
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 29vw;
  }
`;


class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileNavOpen: false,
      privacyPageOpen: false
    };

    this.toggleMobileNav = this.toggleMobileNav.bind(this);
    this.updateMobileNavOpen = this.updateMobileNavOpen.bind(this);
    this.privacyPolicyToggle = this.privacyPolicyToggle.bind(this);
  }

  componentDidMount() {
    const screenWidth = window.innerWidth;

    window.PagesSweeper = new Swiper('.swiper-container', {
      loop: false,
      pagination: null,
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      spaceBetween: 200,
      autoHeight: !(screenWidth > 991),
      mousewheelControl: true,
      keyboardControl: true,
      speed: 1300,
      onSlideChangeEnd: (swiper => onSlideAnimations(swiper))
    });

    window.onresize = () => {
      if (window.innerWidth > 991) {
        window.PagesSweeper.params.autoHeight = false;
      } else {
        window.PagesSweeper.params.autoHeight = true;
      }

      window.PagesSweeper.update();
    };
  }

  toggleMobileNav() {
    const { mobileNavOpen } = this.state;

    this.setState({
      mobileNavOpen: !mobileNavOpen
    });
  }

  updateMobileNavOpen(state) {
    const hamburger = document.getElementById('hamburger');

    if (state.isOpen) {
      hamburger.classList.add('is-active');
    } else {
      hamburger.classList.remove('is-active');
    }


    this.setState({
      mobileNavOpen: state.isOpen
    });
  }

  privacyPolicyToggle() {
    const { privacyPageOpen } = this.state;

    const privacyContainerElement = document.getElementById('privacy-container');

    if (privacyContainerElement) {
      privacyContainerElement.style.opacity = 0;
    }

    this.setState({
      privacyPageOpen: !privacyPageOpen
    });

    setTimeout(() => {
      if (!privacyPageOpen) {
        document.getElementById('privacy-container').style.opacity = 1;
      }
    }, 400);
  }

  render() {
    const { mobileNavOpen, privacyPageOpen } = this.state;

    return (
      <div>
        <MobileNav
          mobileNavOpen={mobileNavOpen}
          updateMobileNavOpen={this.updateMobileNavOpen}
        />
        <AppContainer className="App" id="app-container">
          <MainNav
            toggleMobileNav={this.toggleMobileNav}
          />

          <MainContent id="main-content">
            <PagesContainer>
              <div className="swiper-container">
                <div className="swiper-wrapper">
                  <div className="swiper-slide slide1"><Home /></div>
                  <div className="swiper-slide slide2"><Services /></div>
                  <div className="swiper-slide slide3"><Work /></div>
                  <div className="swiper-slide slide4"><OurClients /></div>
                  <div className="swiper-slide slide5"><ForDevelopers /></div>
                  <div className="swiper-slide slide6"><Contact /></div>
                  <div className="swiper-slide slide7"><WorkWithUs /></div>
                </div>
              </div>
            </PagesContainer>
          </MainContent>

          {privacyPageOpen &&
            <PrivacyContainer id="privacy-container">
              <PrivacyPage>
                <h2 className="first-title">Your Privacy</h2>
                <p>
                  Your privacy is important to us. To better protect your privacy we provide
                  this notice explaining our online information practices and the choices you
                  can make about the way your information is collected and used. To make
                  this notice easy to find, we make it available on our homepage and at
                  every point where personally identifiable information may be requested.
                </p>
                <h2>Collection of Personal Information</h2>
                <p>
                  When visiting Leafy Code, the IP address used to access the site will be
                  logged along with the dates and times of access. This information is purely
                  used to analyze trends, administer the site, track users movement and gather
                  broad demographic information for internal use. Most importantly, any
                  recorded IP addresses are not linked to personally identifiable information.
                </p>
                <h2>Links to third party Websites</h2>
                <p>
                  We have included links on this site for your use and reference. We are not
                  responsible for the privacy policies on these websites. You should be aware
                  that the privacy policies of these sites may differ from our own.
                </p>
                <h2>Changes to this Privacy Statement</h2>
                <p>
                  The contents of this statement may be altered at any time, at our discretion.
                  If you have any questions regarding the privacy policy of LeafyCode
                  then you may Contact Us. Last updated Thu, 29 June 2017 03:18 PM IST
                </p>
                <ClosePrivacyButton onClick={this.privacyPolicyToggle}>
                  <span className="link-text" >Close</span>
                </ClosePrivacyButton>
              </PrivacyPage>
            </PrivacyContainer>
          }

          <Footer privacyPolicyToggle={this.privacyPolicyToggle} />
        </AppContainer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js